import PROPERTY_LIMITATIONS from "../../json/PropertyLimitations.json";

export default class PropertyService {
  static isValidValue(value, type) {
    if (isNaN(parseFloat(value))) {
      return false;
    }
    if (type === "initialInventory") {
      return (
        value >= PROPERTY_LIMITATIONS.INITIAL_INVENTORY_MIN &&
        value <= PROPERTY_LIMITATIONS.INITIAL_INVENTORY_MAX
      );
    }
    if (type === "orderingFrequency") {
      return (
        value >= PROPERTY_LIMITATIONS.ORDERING_FREQUENCY_MIN &&
        value <= PROPERTY_LIMITATIONS.ORDERING_FREQUENCY_MAX
      );
    }
    if (type === "minOrderQuantity") {
      return (
        value >= PROPERTY_LIMITATIONS.MIN_ORDER_QUANTITY_MIN &&
        value <= PROPERTY_LIMITATIONS.MIN_ORDER_QUANTITY_MAX
      );
    }
    if (type === "orderingQuantum") {
      return (
        value >= PROPERTY_LIMITATIONS.ORDERING_QUANTUM_MIN &&
        value <= PROPERTY_LIMITATIONS.ORDERING_QUANTUM_MAX
      );
    }
    if (type === "tslRedLevel") {
      return (
        value >= PROPERTY_LIMITATIONS.TSL_RED_LEVEL_MIN &&
        value <= PROPERTY_LIMITATIONS.TSL_RED_LEVEL_MAX
      );
    }
    if (type === "tslYellowLevel") {
      return (
        value >= PROPERTY_LIMITATIONS.TSL_YELLOW_LEVEL_MIN &&
        value <= PROPERTY_LIMITATIONS.TSL_YELLOW_LEVEL_MAX
      );
    }
    if (type === "absoluteMinimumTSL") {
      return (
        value >= PROPERTY_LIMITATIONS.ABSOLUTE_MINIMUM_TSL_MIN &&
        value <= PROPERTY_LIMITATIONS.ABSOLUTE_MINIMUM_TSL_MAX
      );
    }
    if (type === "tslRoundingMultiple") {
      return (
        value >= PROPERTY_LIMITATIONS.TSL_ROUNDING_MULTIPLE_MIN &&
        value <= PROPERTY_LIMITATIONS.TSL_ROUNDING_MULTIPLE_MAX
      );
    }
    if (type === "initialTSLCalculationWindowSizeRRTs") {
      return (
        value >=
          PROPERTY_LIMITATIONS.INITIAL_TSL_CALCULATION_WINDOW_SIZE_RRTS_MIN &&
        value <=
          PROPERTY_LIMITATIONS.INITIAL_TSL_CALCULATION_WINDOW_SIZE_RRTS_MAX
      );
    }
    if (type === "hybridAdjustmentHorizonRRTs") {
      return (
        value >= PROPERTY_LIMITATIONS.HYBRID_ADJUSTMENT_HORIZON_RRTS_MIN &&
        value <= PROPERTY_LIMITATIONS.HYBRID_ADJUSTMENT_HORIZON_RRTS_MAX
      );
    }
    if (type === "hybridIncreaseThreshold") {
      return (
        value >= PROPERTY_LIMITATIONS.HYBRID_INCREASE_THRESHOLD_MIN &&
        value <= PROPERTY_LIMITATIONS.HYBRID_INCREASE_THRESHOLD_MAX
      );
    }
    if (type === "hybridDecreaseThreshold") {
      return (
        value >= PROPERTY_LIMITATIONS.HYBRID_DECREASE_THRESHOLD_MIN &&
        value <= PROPERTY_LIMITATIONS.HYBRID_DECREASE_THRESHOLD_MAX
      );
    }
    if (type === "targetBufferIncreasePercent") {
      return (
        value >= PROPERTY_LIMITATIONS.TARGET_BUFFER_INCREASE_PERCENT_MIN &&
        value <= PROPERTY_LIMITATIONS.TARGET_BUFFER_INCREASE_PERCENT_MAX
      );
    }
    if (type === "targetBufferDecreasePercent") {
      return (
        value >= PROPERTY_LIMITATIONS.TARGET_BUFFER_DECREASE_PERCENT_MIN &&
        value <= PROPERTY_LIMITATIONS.TARGET_BUFFER_DECREASE_PERCENT_MAX
      );
    }
    if (type === "redSlidingWindowSizeInRRTs") {
      return (
        value >= PROPERTY_LIMITATIONS.RED_SLIDING_WINDOW_SIZE_IN_RRTS_MIN &&
        value <= PROPERTY_LIMITATIONS.RED_SLIDING_WINDOW_SIZE_IN_RRTS_MAX
      );
    }
    if (type === "greenSlidingWindowSizeInRRTs") {
      return (
        value >= PROPERTY_LIMITATIONS.GREEN_SLIDING_WINDOW_SIZE_IN_RRTS_MIN &&
        value <= PROPERTY_LIMITATIONS.GREEN_SLIDING_WINDOW_SIZE_IN_RRTS_MAX
      );
    }
    if (type === "redToleranceTimeInRRTs") {
      return (
        value >= PROPERTY_LIMITATIONS.RED_TOLERANCE_TIME_IN_RRTS_MIN &&
        value <= PROPERTY_LIMITATIONS.RED_TOLERANCE_TIME_IN_RRTS_MAX
      );
    }
    if (type === "useRedDaysBasedRuleForTSLBelow") {
      return (
        value >=
          PROPERTY_LIMITATIONS.USE_RED_DAYS_BASED_RULE_FOR_TSL_BELOW_MIN &&
        value <= PROPERTY_LIMITATIONS.USE_RED_DAYS_BASED_RULE_FOR_TSL_BELOW_MAX
      );
    }
    if (type === "redDaysBackwardLookingHorizonRRTs") {
      return (
        value >=
          PROPERTY_LIMITATIONS.RED_DAYS_BACKWARD_LOOKING_HORIZON_RRTS_MIN &&
        value <= PROPERTY_LIMITATIONS.RED_DAYS_BACKWARD_LOOKING_HORIZON_RRTS_MAX
      );
    }
    if (type === "redPenetrationThreshold") {
      return (
        value >= PROPERTY_LIMITATIONS.RED_PENETRATION_THRESHOLD_MIN &&
        value <= PROPERTY_LIMITATIONS.RED_PENETRATION_THRESHOLD_MAX
      );
    }
    if (type === "redDaysNumberToIncreaseTSL") {
      return (
        value >= PROPERTY_LIMITATIONS.RED_DAYS_NUMBER_TO_INCREASE_TSL_MIN &&
        value <= PROPERTY_LIMITATIONS.RED_DAYS_NUMBER_TO_INCREASE_TSL_MAX
      );
    }
    if (type === "greenPeriodToDecreaseTSLRRTs") {
      return (
        value >= PROPERTY_LIMITATIONS.GREEN_PERIOD_TO_DECREASE_TSLRRTS_MIN &&
        value <= PROPERTY_LIMITATIONS.GREEN_PERIOD_TO_DECREASE_TSLRRTS_MAX
      );
    }
    if (type === "waitingPeriodBeforeCheckingToIncreaseTSLRRTs") {
      return (
        value >=
          PROPERTY_LIMITATIONS.WAITING_PERIOD_BEFORE_CHECKING_TO_INCREASE_TSLRRTS_MIN &&
        value <=
          PROPERTY_LIMITATIONS.WAITING_PERIOD_BEFORE_CHECKING_TO_INCREASE_TSLRRTS_MAX
      );
    }
    if (type === "consumptionTimeWindowRRTs") {
      return (
        value >= PROPERTY_LIMITATIONS.CONSUMPTION_TIME_WINDOW_RRTS_MIN &&
        value <= PROPERTY_LIMITATIONS.CONSUMPTION_TIME_WINDOW_RRTS_MAX
      );
    }
    if (type === "zoneQuantum") {
      return (
        value >= PROPERTY_LIMITATIONS.ZONE_QUANTUM_MIN &&
        value <= PROPERTY_LIMITATIONS.ZONE_QUANTUM_MAX
      );
    }
    if (type === "recalculationFrequency") {
      return (
        value >= PROPERTY_LIMITATIONS.RECALCULATION_FREQUENCY_MIN &&
        value <= PROPERTY_LIMITATIONS.RECALCULATION_FREQUENCY_MAX
      );
    }
    if (type === "considerationPeriod") {
      return (
        value >= PROPERTY_LIMITATIONS.CONSIDERATION_PERIOD_MIN &&
        value <= PROPERTY_LIMITATIONS.CONSIDERATION_PERIOD_MAX
      );
    }
    if (type === "forwardConsideration") {
      return (
        value >= PROPERTY_LIMITATIONS.FORWARD_CONSIDERATION_MIN &&
        value <= PROPERTY_LIMITATIONS.FORWARD_CONSIDERATION_MAX
      );
    }
    if (type === "variabilityFactor") {
      return (
        value >= PROPERTY_LIMITATIONS.VARIABILITY_FACTOR_MIN &&
        value <= PROPERTY_LIMITATIONS.VARIABILITY_FACTOR_MAX
      );
    }
    if (type === "redZoneLeadTimeFactor") {
      return (
        value >= PROPERTY_LIMITATIONS.RED_ZONE_LEAD_TIME_FACTOR_MIN &&
        value <= PROPERTY_LIMITATIONS.RED_ZONE_LEAD_TIME_FACTOR_MAX
      );
    }
    if (type === "greenZoneLeadTimeFactor") {
      return (
        value >= PROPERTY_LIMITATIONS.GREEN_ZONE_LEAD_TIME_FACTOR_MIN &&
        value <= PROPERTY_LIMITATIONS.GREEN_ZONE_LEAD_TIME_FACTOR_MAX
      );
    }
    if (type === "qualifiedSpikeHorizon") {
      return (
        value >= PROPERTY_LIMITATIONS.QUALIFIED_SPIKE_HORIZON_MIN &&
        value <= PROPERTY_LIMITATIONS.QUALIFIED_SPIKE_HORIZON_MAX
      );
    }
    if (type === "qualifiedSpikeSizeFractionTopOfRed") {
      return (
        value >=
          PROPERTY_LIMITATIONS.QUALIFIED_SPIKE_SIZE_FRACTION_TOP_OF_RED_MIN &&
        value <=
          PROPERTY_LIMITATIONS.QUALIFIED_SPIKE_SIZE_FRACTION_TOP_OF_RED_MAX
      );
    }
    if (type === "dltRecalculationHorizonDLTs") {
      return (
        value >= PROPERTY_LIMITATIONS.DLT_RECALCULATION_HORIZON_DLTS_MIN &&
        value <= PROPERTY_LIMITATIONS.DLT_RECALCULATION_HORIZON_DLTS_MAX
      );
    }
  }

  static roundProperty(property, multiply, scale) {
    return (Math.round(property * multiply) / multiply).toFixed(scale);
  }

  static sliceDate(date, sliceTo) {
    return date.toISOString().slice(0, sliceTo);
  }

  static roundingDouble(number) {
    return Math.round(number * 100) / 100;
  }
}
